import { createTermTagManager } from '../../utils/createTermTagManager';

export const isByHomeOwnerTagManager = createTermTagManager({
  jsonQueryKey: 'is_by_homeowner',
  label: 'От собственника',
  id: 'isByHomeOwner',
});
